import { ReactNode, useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  containerId?: string;
}

export function Portal({ children, containerId = 'portal-root' }: PortalProps) {
  const [mounted, setMounted] = useState(false);
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find or create the portal container
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = containerId;
      document.body.appendChild(container);
    }

    // Wrap setState in setTimeout to avoid direct state setting in effect
    const timer = setTimeout(() => {
      setMounted(true);
      setPortalElement(container);
    }, 0);

    return () => {
      clearTimeout(timer);
      // Cleanup: remove the container if it's empty
      if (container && container.childNodes.length === 0) {
        container.remove();
      }
    };
  }, [containerId]);

  if (!mounted || !portalElement) {
    return null;
  }

  return createPortal(children, portalElement);
}
